import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { useEffect, useRef } from 'react';
import { BmSidebar } from './bm-sidebar';

// Track if any instance of this hook is currently mounted
let activeMountCount = 0;
let reopenTimeoutId = null;
let wasOriginallyOpen = false;
export const DomainsSearchGateBMExtension = createModuleExtension({
  extensionName: 'domains-search-gate-bm-extension',
  SDK: {
    hooks: {
      useDomainsSearchGateBM: () => {
        const isFirstMountRef = useRef(activeMountCount === 0);
        useEffect(() => {
          const bmSidebar = new BmSidebar();

          // Cancel any pending reopen
          if (reopenTimeoutId) {
            clearTimeout(reopenTimeoutId);
            reopenTimeoutId = null;
          }

          // Only store the original state on the very first mount
          if (isFirstMountRef.current) {
            wasOriginallyOpen = bmSidebar.isOpen;
          }

          // Increment mount count
          activeMountCount++;

          // Always close the sidebar
          bmSidebar.close();
          return () => {
            // Decrement mount count
            activeMountCount--;

            // Wait a bit before reopening to see if another instance will mount
            reopenTimeoutId = setTimeout(() => {
              // Only reopen sidebar if no other instances are mounted (leaving the module)
              if (activeMountCount === 0 && wasOriginallyOpen) {
                bmSidebar.open();
                // Reset the state
                wasOriginallyOpen = false;
              }
              reopenTimeoutId = null;
            }, 100);
          };
        }, []);
      }
    }
  }
});
//# sourceMappingURL=DomainsSearchGateBMExtension.js.map